
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/connections",
      function () {
        return require("private-next-pages/context-hub/connections.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/connections"])
      });
    }
  